/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Icon_AltInputs */

const en_iconik_publish_icon_alt = /** @type {(inputs: Iconik_Publish_Icon_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iconik icon`)
};

const fr_iconik_publish_icon_alt = /** @type {(inputs: Iconik_Publish_Icon_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`icone iconik`)
};

const de_iconik_publish_icon_alt = /** @type {(inputs: Iconik_Publish_Icon_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik-Symbol`)
};

const it_iconik_publish_icon_alt = /** @type {(inputs: Iconik_Publish_Icon_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`icona iconica`)
};

const ru_iconik_publish_icon_alt = /** @type {(inputs: Iconik_Publish_Icon_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`иконическая икона`)
};

const es_iconik_publish_icon_alt = /** @type {(inputs: Iconik_Publish_Icon_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`icono de iconik`)
};

const zh_cn2_iconik_publish_icon_alt = /** @type {(inputs: Iconik_Publish_Icon_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iconik 图标`)
};

const ja_iconik_publish_icon_alt = /** @type {(inputs: Iconik_Publish_Icon_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iconikアイコン`)
};

const hi_iconik_publish_icon_alt = /** @type {(inputs: Iconik_Publish_Icon_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइकॉनिक आइकन`)
};

const pt_pt2_iconik_publish_icon_alt = /** @type {(inputs: Iconik_Publish_Icon_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ícone icônico`)
};

/**
* | output |
* | --- |
* | "iconik icon" |
*
* @param {Iconik_Publish_Icon_AltInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_icon_alt = /** @type {((inputs?: Iconik_Publish_Icon_AltInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Icon_AltInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_icon_alt(inputs)
	if (locale === "de") return de_iconik_publish_icon_alt(inputs)
	if (locale === "it") return it_iconik_publish_icon_alt(inputs)
	if (locale === "ru") return ru_iconik_publish_icon_alt(inputs)
	if (locale === "es") return es_iconik_publish_icon_alt(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_icon_alt(inputs)
	if (locale === "ja") return ja_iconik_publish_icon_alt(inputs)
	if (locale === "hi") return hi_iconik_publish_icon_alt(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_icon_alt(inputs)
	return en_iconik_publish_icon_alt(inputs)
});